import {
  LayoutAdmin,
  LayoutCampo,
  RedirigirPorRol,
  RequiereAuth,
  RequiereRol,
} from '@/components/layout';
import { AnalisisMensualPantalla } from '@/pages/AnalisisMensualPantalla';
import { CierrePantalla } from '@/pages/CierrePantalla';
import { LoginPantalla } from '@/pages/LoginPantalla';
import { NoEncontradoPantalla } from '@/pages/NoEncontradoPantalla';
import { ObrasPantalla } from '@/pages/ObrasPantalla';
import { PresupuestosPantalla } from '@/pages/PresupuestosPantalla';
import { ReportesPantalla } from '@/pages/ReportesPantalla';
import { CalidadFichasPantalla } from '@/pages/admin/CalidadFichasPantalla';
import { CausasPantalla } from '@/pages/admin/CausasPantalla';
import { CentrosCostoFotosPantalla } from '@/pages/admin/CentrosCostoFotosPantalla';
import { FichaEditorPantalla } from '@/pages/admin/FichaEditorPantalla';
import { HorasObraPantalla } from '@/pages/admin/HorasObraPantalla';
import { IntegracionBcObraPantalla } from '@/pages/admin/IntegracionBcObraPantalla';
import { IntegracionBcPantalla } from '@/pages/admin/IntegracionBcPantalla';
import { NominaSemanalPantalla } from '@/pages/admin/NominaSemanalPantalla';
import { PesosPantalla } from '@/pages/admin/PesosPantalla';
import { SprintsPantalla } from '@/pages/admin/SprintsPantalla';
import { SubPartidasPantalla } from '@/pages/admin/SubPartidasPantalla';
import { SubcontratosPantalla } from '@/pages/admin/SubcontratosPantalla';
import { TiposCasaPantalla } from '@/pages/admin/TiposCasaPantalla';
import { UsuariosPantalla } from '@/pages/admin/UsuariosPantalla';
import { CampoAvancePantalla } from '@/pages/campo/CampoAvancePantalla';
import { CampoObrasPantalla } from '@/pages/campo/CampoObrasPantalla';
import { RegistroCalidadPantalla } from '@/pages/campo/RegistroCalidadPantalla';
import { FotosPantalla } from '@/pages/fotos/FotosPantalla';
import { GaleriaObraPantalla } from '@/pages/fotos/GaleriaObraPantalla';
import { Navigate, createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter(
  [
    // Login: público, sin layout
    { path: '/login', element: <LoginPantalla /> },

    // Index: redirige según el rol del usuario activo
    {
      path: '/',
      element: (
        <RequiereAuth>
          <RedirigirPorRol />
        </RequiereAuth>
      ),
    },

    // Área Admin — desktop-first. Acceso: admin + supervisor.
    // Catálogos y Usuarios quedan SOLO para admin (RequiereRol por ruta).
    {
      path: '/admin',
      element: (
        <RequiereAuth>
          <RequiereRol roles={['admin', 'supervisor']}>
            <LayoutAdmin />
          </RequiereRol>
        </RequiereAuth>
      ),
      children: [
        { index: true, element: <Navigate to="/admin/obras" replace /> },
        { path: 'obras', element: <ObrasPantalla /> },
        {
          path: 'integracion-bc',
          element: (
            <RequiereRol roles={['admin']}>
              <IntegracionBcPantalla />
            </RequiereRol>
          ),
        },
        {
          path: 'integracion-bc/:obra',
          element: (
            <RequiereRol roles={['admin']}>
              <IntegracionBcObraPantalla />
            </RequiereRol>
          ),
        },
        // Catálogos / parámetros — solo admin
        {
          path: 'presupuestos',
          element: (
            <RequiereRol roles={['admin']}>
              <PresupuestosPantalla />
            </RequiereRol>
          ),
        },
        {
          path: 'sub-partidas',
          element: (
            <RequiereRol roles={['admin']}>
              <SubPartidasPantalla />
            </RequiereRol>
          ),
        },
        {
          path: 'tipos-casa',
          element: (
            <RequiereRol roles={['admin']}>
              <TiposCasaPantalla />
            </RequiereRol>
          ),
        },
        {
          path: 'sprints',
          element: (
            <RequiereRol roles={['admin']}>
              <SprintsPantalla />
            </RequiereRol>
          ),
        },
        {
          path: 'pesos',
          element: (
            <RequiereRol roles={['admin']}>
              <PesosPantalla />
            </RequiereRol>
          ),
        },
        {
          path: 'causas',
          element: (
            <RequiereRol roles={['admin']}>
              <CausasPantalla />
            </RequiereRol>
          ),
        },
        {
          path: 'calidad-fichas',
          element: (
            <RequiereRol roles={['admin']}>
              <CalidadFichasPantalla />
            </RequiereRol>
          ),
        },
        {
          path: 'calidad-fichas/:id',
          element: (
            <RequiereRol roles={['admin']}>
              <FichaEditorPantalla />
            </RequiereRol>
          ),
        },
        {
          path: 'centros-costo-fotos',
          element: (
            <RequiereRol roles={['admin']}>
              <CentrosCostoFotosPantalla />
            </RequiereRol>
          ),
        },
        // Mano de obra — admin + supervisor (heredan el guard de capa)
        { path: 'mo-nomina', element: <NominaSemanalPantalla /> },
        { path: 'mo-horas', element: <HorasObraPantalla /> },
        { path: 'mo-subcontratos', element: <SubcontratosPantalla /> },
        // Usuarios — solo admin
        {
          path: 'usuarios',
          element: (
            <RequiereRol roles={['admin']}>
              <UsuariosPantalla />
            </RequiereRol>
          ),
        },
        { path: 'cierre', element: <CierrePantalla /> },
        { path: 'reportes', element: <ReportesPantalla /> },
        { path: 'analisis-mensual', element: <AnalisisMensualPantalla /> },
        // Fotos de obra (admin + supervisor)
        { path: 'fotos', element: <FotosPantalla /> },
        { path: 'fotos/:obra', element: <GaleriaObraPantalla /> },
      ],
    },

    // Área Campo — mobile-first, PWA-instalable
    {
      path: '/campo',
      element: (
        <RequiereAuth>
          <LayoutCampo />
        </RequiereAuth>
      ),
      children: [
        { index: true, element: <Navigate to="/campo/avance" replace /> },
        // Avance unificado: el selector de obra vive acá; la captura en :codigo.
        { path: 'avance', element: <CampoObrasPantalla /> },
        { path: 'avance/:codigo', element: <CampoAvancePantalla /> },
        // Fotos de obra: todos los roles (también visualizador) toman y ven fotos.
        { path: 'fotos', element: <FotosPantalla /> },
        { path: 'fotos/:obra', element: <GaleriaObraPantalla /> },
        // Ficha de control de calidad (inspección / evaluación).
        { path: 'calidad/:id', element: <RegistroCalidadPantalla /> },
        // Compatibilidad con el viejo /campo/obras → ahora es /campo/avance.
        { path: 'obras', element: <Navigate to="/campo/avance" replace /> },
        // Cierre desde campo: solo gestión (admin + supervisor); campo no cierra.
        {
          path: 'cierre',
          element: (
            <RequiereRol roles={['admin', 'supervisor']}>
              <CierrePantalla />
            </RequiereRol>
          ),
        },
        { path: 'reportes', element: <ReportesPantalla /> },
      ],
    },

    // Catch-all global
    { path: '*', element: <NoEncontradoPantalla /> },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);
